// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__+CwAJ","updated":"Heading_updated__ZljoT"};